<div class="w-full relative max-h-96 overflow-auto">
  @for (version of versions; track version) {
    <h4>
      {{ version.title }} - <i>{{ version.date }}</i>
    </h4>
    <br />
    <h4>What's new</h4>
    @for (section of version.sections; track section) {
      <div>
        <strong>{{ section.title }}</strong>
      </div>
      <ul>
        @for (item of section.children; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    }
    <hr />
  }
</div>
<div
  class="mt-3 flex justify-between flex-wrap bg-app-white-75 text-app-dark p-4 rounded-2xl"
>
  <div>Expires On: {{ expirationDate }}</div>
  <div>Max Agents: {{ maxAgents }}</div>
  @if (timeUntilAgentExpiration) {
    <div>Agents Expiration in: {{ timeUntilAgentExpiration }}</div>
  }
</div>
